import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3 flex justify-between rounded-md bg-white border-2 border-gray-200" }
const _hoisted_2 = { class: "w-8/12" }
const _hoisted_3 = { class: "mt-4 mb-1 flex-1 flex justify-between items-center" }
const _hoisted_4 = { class: "text-xs text-gray-500 grid grid-cols-3 gap-2 content-start" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 最新提出時刻")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "font-bold break-words" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 表示期間")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "font-bold break-words" }
const _hoisted_11 = { class: "w-4/12" }
const _hoisted_12 = { class: "flex justify-end mb-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "mr-2" }, "提出物を確認する", -1)
const _hoisted_14 = { class: "flex justify-end" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "mr-2" }, "全生徒の提出状況", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", null, _toDisplayString(_ctx.title) + "_" + _toDisplayString(_ctx.label), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", null, [
            _hoisted_5,
            _hoisted_6,
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.latestPostTime ? `${_ctx.toTimeString(_ctx.latestPostTime)}` : "--"), 1)
          ]),
          _createVNode("div", null, [
            _hoisted_8,
            _hoisted_9,
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.toDateString(_ctx.submittableFrom)) + "~" + _toDisplayString(_ctx.toDateString(_ctx.displayEndAt)), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_m_button, {
          color: "gray-500",
          size: "sm",
          "font-weight": "normal",
          text: "",
          onClick: _ctx.click,
          isDiv: true
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createVNode(_component_m_icon, { type: "external" })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_m_button, {
          color: "gray-500",
          size: "sm",
          "font-weight": "normal",
          text: "",
          link: `/thread_master/${_ctx.threadMasterId}`
        }, {
          default: _withCtx(() => [
            _hoisted_15,
            _createVNode(_component_m_icon, { type: "people" })
          ]),
          _: 1
        }, 8, ["link"])
      ])
    ])
  ]))
}